import React from 'react';
import { Outlet } from 'react-router-dom';
import { AppBar, Toolbar, IconButton, Typography, Container, Box, Button, Link, Menu } from '@mui/material';
import { Link as RLink, useNavigate } from "react-router-dom";
import MenuIcon from '@mui/icons-material/Menu'

import Logo from '../../assets/wiredefense_logo.png';

export function Header() {
  const navigate = useNavigate();

  return (
    <AppBar position="sticky" sx={{
      background: '#00000022',
      backdropFilter: 'blur(3px)',
      boxShadow: '0px 1px 10px 0px #00000044',
    }}>
      <Toolbar sx={{
        // backgroundColor: '#12121200'
      }}>
        {/* <IconButton edge="start" color="inherit" aria-label="menu" sx={{ mr: 2 }}>
        <MenuIcon />
      </IconButton> */}
        <Box sx={{ height: { xs: '36px', sm: '48px' }, }}>
          <RLink to="/">
            <Box
              component="img"
              src={Logo}
              sx={{ height: '100%', width: 'auto' }}
              alt="WireDefense Logo"
            />
          </RLink>
        </Box>

        <Box sx={{ flexGrow: 1 }} />

        <Button
          color="inherit"
          sx={{
            fontSize: { xs: '0.8rem', sm: '1rem' },
            display: { xs: 'none', sm: 'flex' },
          }}
          onClick={() => {
            navigate('/')
            window.scrollTo({
              top: 0,
              behavior: "smooth",
            })
          }}>
          Features
        </Button>
        <Button
          color="inherit"
          sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}
          onClick={() => {
            navigate('/app')
          }}>
          Configs
        </Button>
        <Button
          color="inherit"
          sx={{ fontSize: { xs: '0.8rem', sm: '1rem' } }}
          onClick={() => {
            navigate('/app/topup')
          }}>
          Subscription
        </Button>
      </Toolbar>
    </AppBar>
  );
}

export default Header;
